import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

export interface FilePreviewConfig {
  fileName: string;
  blob: Blob;
  downloadFn: () => void;
}

export type OverlayState =
  | { phase: 'loading'; fileName: string }
  | { phase: 'ready'; config: FilePreviewConfig };

@Injectable({ providedIn: 'root' })
export class FilePreviewOverlayService {
  private readonly stateSubject = new BehaviorSubject<OverlayState | null>(null);
  readonly state$ = this.stateSubject.asObservable();

  openLoading(fileName: string): void {
    this.stateSubject.next({ phase: 'loading', fileName });
  }

  open(config: FilePreviewConfig): void {
    this.stateSubject.next({ phase: 'ready', config });
  }

  close(): void {
    this.stateSubject.next(null);
  }
}
